export default "__VITE_ASSET__D1f0MeTB__"